import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Ertigaonrentinmumbai() {



  const cardData = {
    keyword: " Ertiga On Rent in Mumbai ",


"headingDescription": "Royal Route Cab offers affordable and spacious Ertiga on rent in Mumbai, providing a perfect travel solution for families, corporate groups, airport transfers, and outstation journeys. The Maruti Suzuki Ertiga is one of the most popular 7-seater MPVs known for its comfortable seating, excellent mileage, and smooth driving experience in city and highway conditions. Our well-maintained Ertiga vehicles come with professional drivers, ensuring a safe, convenient, and stress-free journey across Mumbai and nearby destinations. Rental pricing for Ertiga in Mumbai typically ranges between ₹14 to ₹16 per km for outstation travel and around ₹2800 to ₹3500 for local packages depending on duration and distance. :contentReference[oaicite:0]{index=0} We offer flexible booking options including one-way, round trip, and hourly rentals with transparent pricing and no hidden charges. With 24/7 availability and easy booking, Royal Route Cab is your trusted choice for Ertiga rental in Mumbai.",

"topPlaces": [
  {
    "title": "Ertiga On Rent in Mumbai",
    "description": "Ertiga on rent in Mumbai is a popular choice for families, tourists, and business travelers looking for a comfortable and budget-friendly travel option. With spacious seating and modern features, it is suitable for local travel, airport transfers, and outstation trips."
  },
  {
    "title": "Ertiga Rental Service Mumbai",
    "description": "Ertiga rental service in Mumbai provides convenient and affordable transportation for family vacations, corporate travel, weddings, and sightseeing tours. The vehicle offers a comfortable ride while accommodating passengers and luggage with ease."
  },
  {
    "title": "Ertiga with Driver Mumbai",
    "description": "Ertiga with driver services in Mumbai allow travelers to enjoy a stress-free journey with professional chauffeur assistance. It is an ideal option for city travel, airport transfers, and business meetings."
  },
  {
    "title": "Mumbai Airport Ertiga Rental",
    "description": "Mumbai Airport Ertiga rental services are preferred by travelers who need reliable airport pickup and drop-off facilities. The vehicle offers comfortable seating and sufficient luggage space for a hassle-free airport transfer experience."
  },
  {
    "title": "Affordable Ertiga Rental Mumbai",
    "description": "Affordable Ertiga rental in Mumbai is an excellent option for customers seeking economical transportation without compromising comfort. It is widely used for daily travel, family outings, and weekend trips."
  },
  {
    "title": "Ertiga for Outstation Trips from Mumbai",
    "description": "Ertiga is a preferred vehicle for outstation travel from Mumbai due to its fuel efficiency, comfortable seating, and spacious interiors. It is suitable for family trips to destinations such as Lonavala, Pune, Nashik, and Mahabaleshwar."
  },
  {
    "title": "Corporate Ertiga Rental Mumbai",
    "description": "Corporate Ertiga rental services in Mumbai are ideal for business professionals and teams attending meetings, conferences, and corporate events. The vehicle provides a comfortable and professional travel experience."
  },
  {
    "title": "Ertiga for Family Trips Mumbai",
    "description": "Families traveling in and around Mumbai often choose Ertiga rentals because of the vehicle’s spacious cabin and comfortable seating arrangement. It is perfect for local sightseeing and group outings."
  },
  {
    "title": "Ertiga Hire Mumbai",
    "description": "Ertiga hire services in Mumbai offer flexible rental options for short-term and long-term travel needs. Customers prefer the vehicle for its practicality, affordability, and passenger comfort."
  },
  {
    "title": "Best Ertiga Cab Service Mumbai",
    "description": "Best Ertiga cab services in Mumbai provide reliable transportation solutions for airport transfers, local sightseeing, corporate travel, and outstation journeys. The vehicle is known for its comfort, safety, and value for money."
  }
],






services: [
  {
    name: "Ertiga on Rent Mumbai",
    description: "Ertiga on rent Mumbai offers a perfect balance of comfort, space, and affordability for family and group travel. This MPV is ideal for city rides, airport transfers, and outstation journeys. Clean vehicles and professional drivers ensure a smooth experience. It guarantees a comfortable and budget-friendly journey."
  },
  {
    name: "Ertiga Cab Service Mumbai",
    description: "Ertiga cab service Mumbai provides reliable transportation with spacious and comfortable vehicles. This service is ideal for families, small groups, and corporate travel. Professional drivers ensure safe and timely service. It ensures a smooth and hassle-free travel experience."
  },
  {
    name: "Maruti Ertiga Rental Mumbai",
    description: "Maruti Ertiga rental Mumbai offers well-maintained MPV vehicles designed for comfort and efficiency. This service is suitable for both local and long-distance travel. Spacious seating and good mileage enhance the journey. It ensures a pleasant travel experience."
  },
  {
    name: "Ertiga Taxi Mumbai",
    description: "Ertiga taxi Mumbai provides convenient and affordable transportation for group travel. This service is ideal for city rides, airport transfers, and family outings. Experienced drivers ensure safe travel. It guarantees a reliable journey."
  },
  {
    name: "Ertiga Car Hire Mumbai",
    description: "Ertiga car hire Mumbai allows customers to rent a spacious MPV for flexible travel needs. This service is ideal for personal, family, and business use. Easy booking and transparent pricing enhance convenience. It ensures a comfortable journey."
  },
  {
    name: "Ertiga Cab Booking Mumbai",
    description: "Ertiga cab booking Mumbai allows travelers to reserve their vehicle easily with flexible options. Customers can select pickup location, timing, and travel plan. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Ertiga Taxi Booking Online Mumbai",
    description: "Ertiga taxi booking online Mumbai provides a quick and convenient way to book MPV cabs. Customers can compare pricing and options easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Ertiga Rental Price Mumbai",
    description: "Ertiga rental price Mumbai varies based on trip type, distance, and duration. Transparent pricing ensures no hidden charges. Budget-friendly packages make it ideal for group travel. It helps travelers plan efficiently. It ensures value for money."
  },
  {
    name: "Ertiga Taxi Fare Mumbai",
    description: "Ertiga taxi fare Mumbai is designed to be affordable for family and group travel. Fare depends on route, usage, and duration. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Ertiga One Way Cab Mumbai",
    description: "Ertiga one way cab Mumbai is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for airport and outstation travel. It ensures smooth and economical travel."
  },
  {
    name: "Ertiga Round Trip Cab Mumbai",
    description: "Ertiga round trip cab Mumbai is ideal for travelers planning return journeys. This service includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family trips and corporate travel. It ensures comfort and efficiency."
  },
  {
    name: "Cheap Ertiga Rental Mumbai",
    description: "Cheap Ertiga rental Mumbai offers budget-friendly options for group travel without compromising comfort. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Ertiga Cab Service Mumbai",
    description: "Best Ertiga cab service Mumbai ensures top-quality vehicles and professional drivers for a smooth travel experience. This service focuses on punctuality, comfort, and customer satisfaction. It guarantees a reliable journey."
  },
  {
    name: "Ertiga Airport Cab Mumbai",
    description: "Ertiga airport cab Mumbai provides spacious and comfortable airport transfers for families and groups. This service ensures timely pickup and drop at terminals. Professional drivers ensure safe travel. It guarantees a stress-free airport experience."
  },
  {
    name: "Ertiga Outstation Cab Mumbai",
    description: "Ertiga outstation cab Mumbai offers reliable long-distance travel with comfortable seating and good mileage. This service is ideal for family vacations and group trips. Vehicles are maintained for highway performance. It ensures a safe and enjoyable journey."
  }
],

tableData: [
  ["Ertiga on Rent Mumbai", "Ertiga Cab Service Mumbai"],
  ["Maruti Ertiga Rental Mumbai", "Ertiga Taxi Mumbai"],
  ["Ertiga Car Hire Mumbai", "Ertiga Cab Booking Mumbai"],
  ["Ertiga Taxi Booking Online Mumbai", "Ertiga Rental Price Mumbai"],
  ["Ertiga Taxi Fare Mumbai", "Ertiga One Way Cab Mumbai"],
  ["Ertiga Round Trip Cab Mumbai", "Cheap Ertiga Rental Mumbai"],
  ["Best Ertiga Cab Service Mumbai", "Ertiga Airport Cab Mumbai"],
  ["Ertiga Outstation Cab Mumbai", "Ertiga on Rent Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable Ertiga on Rent in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers budget-friendly Ertiga rental in Mumbai, perfect for family travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Spacious & Comfortable MPV",
    WhyChoosedescription: "Maruti Ertiga provides comfortable seating for 6-7 passengers with ample luggage space, ideal for group travel."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced, ensuring safe and smooth travel across Mumbai and highways."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing for Ertiga rental including all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Ertiga rental service in Mumbai is available 24/7 for flexible travel anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Ertiga cars are regularly serviced, sanitized, and maintained for a comfortable travel experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Book Ertiga for local Mumbai travel, airport pickup-drop, or outstation trips with customized packages."
  },
  {
    WhyChooseheading: "Trusted MPV Rental Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Ertiga rental service in Mumbai with punctual drivers and smooth service."
  }
]

};

const faqData = [
  { question: "Do you provide Ertiga on rent in Mumbai?", answer: "Yes, Royal Route Cabs offers Ertiga rental services in Mumbai for local and outstation travel." },
  { question: "How many passengers can travel in Ertiga?", answer: "Ertiga can comfortably seat 6 to 7 passengers." },
  { question: "Is Ertiga suitable for long-distance travel?", answer: "Yes, Ertiga is ideal for both city and long-distance travel due to its comfort and space." },
  { question: "Is Ertiga rental available 24 hours?", answer: "Yes, our Ertiga rental service operates 24/7." },
  { question: "Do you provide driver with Ertiga rental?", answer: "Yes, all rentals include professional drivers." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide airport pickup with Ertiga?", answer: "Yes, we offer Mumbai airport pickup and drop services with Ertiga cars." },
  { question: "Can I book Ertiga for one-way trips?", answer: "Yes, we provide one-way and round-trip booking options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harsh Mehta",
    feedback: "Ertiga on rent in Mumbai from Royal Route Cabs was perfect for our family trip. The vehicle was spacious, clean, and very comfortable for long travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Desai",
    feedback: "Booked an Ertiga for a group outing in Mumbai and the experience was excellent. The ride was smooth and the car condition was well maintained.",
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga on Rent in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/ertiga-on-rent-mumbai.jpg", // replace if needed
  "description": "Book Ertiga on rent in Mumbai with Royal Route Cabs for spacious and budget-friendly travel. Ideal for family trips, airport transfers, and outstation journeys. Available for one-way and round-trip cab service with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/ertiga-on-rent-mumbai"
  }
};








  return (
    <div>

<Helmet>
  <title>Ertiga on Rent in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Ertiga on rent in Mumbai with Royal Route Cabs. Affordable and spacious taxi service for airport, local, and outstation travel. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="ertiga on rent mumbai, ertiga cab service mumbai, maruti ertiga rental mumbai, ertiga taxi mumbai, ertiga car hire mumbai, ertiga cab booking mumbai, ertiga taxi booking online mumbai, ertiga rental price mumbai, ertiga taxi fare mumbai, ertiga one way cab mumbai, ertiga round trip cab mumbai, cheap ertiga rental mumbai, best ertiga cab service mumbai, ertiga airport cab mumbai, ertiga outstation cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinmumbai;